import React from "react";
import RegisterForm from "../features/auth/components/register-form";

const RegisterPage = () => {
    return (
        <div className="min-h-screen bg-[#DFE6E7] flex items-center justify-center p-4">
            <div className="max-w-md w-full">
                <div className="flex flex-col gap-12 bg-white rounded-[2rem] shadow-sm p-8 border border-gray-200">
                    <span className="font-semibold text-2xl">Załóż nowe konto</span>
                    <RegisterForm/>
                </div>
            </div>
        </div>
    );
}

export default RegisterPage
